module.exports = __webpack_public_path__ + "static/media/1.21223b50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/3089/1.jpg
// module id = 654
// module chunks = 0